import routerOptions from './router.options';
import coreRoutes from './_core.routes';

import afterEach from './hooks/after-each.hooks';
import beforeEach from './hooks/before-each.hooks';
import beforeResolve from './hooks/before-resolve.hooks';

import homeRoutes from './home.routes';
import decretarRoutes from './decretar.router';
import consultarRoutes from './consultar.router';
import mesaTrabajoRoutes from './mesa-trabajo.router';
import crearRegistroManualRoutes from './crear-registro-manual.router';
import interesadosRoutes from './interesados.routes';
import unidad from './unidad.routes';
import usuariosRoutes from './usuarios.routes';
import permisosNivelesRoutes from './permisos-niveles.router';
import permisosPantallaRoutes from './permisos-pantalla.routes';
import parametrosSistemaRoutes from './parametros-sistema.routes';
import avisosRoutes from './avisos.routes';
import agruparRoutes from './agrupar.routes';
import syncAsifRoutes from './sync-asif.routes';


import modoMantenimientoRoutes from './modo-mantenimiento.routes';
import falloConexionRoutes from './fallo.conexion.routes';
import falloIniciarSesion from './fallo.iniciarSesion.routes ';


const routes = [
  ...homeRoutes,
  ...decretarRoutes,
  ...consultarRoutes,
  ...mesaTrabajoRoutes,
  ...crearRegistroManualRoutes,
  ...interesadosRoutes,
  ...unidad,
  ...usuariosRoutes,
  ...permisosNivelesRoutes,
  ...permisosPantallaRoutes,
  ...parametrosSistemaRoutes,
  ...avisosRoutes,
  ...modoMantenimientoRoutes,
  ...falloConexionRoutes,
  ...falloIniciarSesion,
  ...agruparRoutes,
  ...syncAsifRoutes,
  ...coreRoutes, // (!) Always last
];

const hooks = {
  afterEach,
  beforeEach,
  beforeResolve,
};

export {
  hooks,
  routerOptions,
  routes,
};
